import { Col, Row } from "antd";
import { CloseOutlined, CheckOutlined } from "@ant-design/icons";
import "./style.css";
import { useTranslation } from "react-i18next";
type checkprops = {
    password: boolean;
    checkedPassword: boolean;
    allTrue: boolean;
};
export const CheckPasswordSimple = ({
    password,
    checkedPassword,
    allTrue,
}: checkprops) => {
    const [t] = useTranslation("common");
    return (
        <Row
            className={
                allTrue && checkedPassword
                    ? "password-details correct"
                    : "password-details incorrect"
            }
        >
            <Col>
                <Col offset={1}>
                    {password ? (
                        <CheckOutlined
                            style={{ fontSize: "16px" }}
                            className="check-mark"
                        />
                    ) : (
                        <CloseOutlined style={{ fontSize: "16px" }} className="x-mark" />
                    )}
                    {t("4-20-characters")}
                </Col>
                <Col offset={1}>
                    {checkedPassword ? (
                        <CheckOutlined
                            style={{ fontSize: "16px" }}
                            className="check-mark"
                        />
                    ) : (
                        <CloseOutlined style={{ fontSize: "16px" }} className="x-mark" />
                    )}
                    {t("passwords-matched")}
                </Col>
            </Col>
        </Row>
    );
};
